import React, { Component } from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  type: PropTypes.string,
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  placeholder: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  info: PropTypes.string,
  isDisabled: PropTypes.bool,
  onInputChange: PropTypes.func.isRequired,
  helpText: PropTypes.string,
  maxLength: PropTypes.number,
}

class Input extends Component {
  constructor(props) {
    super(props)
    this.onInputChange = this.onInputChange.bind(this)
  }

  onInputChange(e) {
    const { onInputChange } = this.props
    const val = e.target.value

    // call parent onInputChange method
    if (typeof onInputChange === 'function') {
      onInputChange(val)
    }
  }

  render() {
    const {
      type,
      value,
      placeholder,
      label,
      error,
      info,
      isDisabled,
      maxLength,
      helpText,
      ariaLabel,
      readOnly,
      textArea,
      rows,
    } = this.props

    return (
      <wb-input-control>
        <wb-input>
          <label>{label}</label>
          {(!textArea && (
            <input
              placeholder={placeholder}
              disabled={isDisabled}
              onChange={this.onInputChange}
              aria-label={ariaLabel}
              type={type}
              value={value}
              readOnly={readOnly}
            />
          )) || (
            <textarea
              placeholder={placeholder}
              disabled={isDisabled}
              onChange={this.onInputChange}
              aria-label={ariaLabel}
              value={value}
              readOnly={readOnly}
              rows={rows}
              maxLength={maxLength}
            />
          )}
        </wb-input>
        {info && info.length && (
          <wb-control-hint class="wb-padding-start-xs">{info}</wb-control-hint>
        )}
        {error && error.length && <wb-control-error>{error}</wb-control-error>}
      </wb-input-control>
    )
  }
}

Input.propTypes = propTypes

export default Input
